import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b49671ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-player__wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "video-player__controls-wrapper align-center" }
const _hoisted_4 = { class: "video-player__controls" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/icons/player/ic-rewind.svg",
  width: "100%",
  height: "100%",
  role: "presentation"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  src: "/icons/player/ic-pause.svg",
  width: "100%",
  height: "100%",
  role: "presentation"
}
const _hoisted_10 = {
  src: "/icons/player/ic-play.svg",
  width: "100%",
  height: "100%",
  role: "presentation"
}
const _hoisted_11 = ["title"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/icons/player/ic-forward.svg",
  width: "100%",
  height: "100%",
  role: "presentation"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
    _createElementVNode("video", {
      ref: "videoPlayerRef",
      autoplay: "",
      playsinline: "",
      muted: "",
      loop: "",
      onPlayOnce: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPlayed && _ctx.onPlayed(...args)))
    }, [
      _createElementVNode("source", { src: _ctx.src }, null, 8, _hoisted_2)
    ], 544),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          title: `Rewind for ${_ctx.FORWARD_TIME} seconds`,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRewind && _ctx.onRewind(...args)))
        }, _hoisted_7, 8, _hoisted_5),
        _createElementVNode("button", {
          title: _ctx.playPauseButtonTitle,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPlayPauseClick && _ctx.onPlayPauseClick(...args)))
        }, [
          _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
            [_vShow, !_ctx.isPaused]
          ]),
          _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
            [_vShow, _ctx.isPaused]
          ])
        ], 8, _hoisted_8),
        _createElementVNode("button", {
          title: `Forward for ${_ctx.FORWARD_TIME} seconds`,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onForward && _ctx.onForward(...args)))
        }, _hoisted_13, 8, _hoisted_11)
      ])
    ])
  ]))
}